import PageNotFound from "@/components/app/404";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_portal/404")({
  component: RouteComponent,
});

function RouteComponent() {
  return <PageNotFound />;
}
